module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Bag1-1a50667ff6eaf8177c7c5b8c61714a29.svg";